import {useContext, useState} from "react";
import Guide from "./Guide";
import GetInitInfo from "./GetInitInfo";
import Addon from "./Addon";
import TransactionalCreditContext from "../../tools/contexts/transationcalCredit/TransactionalCreditContext";

const guideDefaultText = {
    title: 'ونیفای',
    description: 'پس از تطابق کدملی و مالکیت شماره همراه در صورت عدم ممنوعیت معاملاتی تاییدیه‌ای مبنی بر آن روی آگهی درج خواهد شد.',
    subTitle: 'استعلام وضعیت معاملاتی'
};
const InitConfirm = () => {
    const selectedAddonType = localStorage.getItem('chooseAddon');
    const [isAddon, setIsAddon] = useState(false);
    const transactionalContext = useContext(TransactionalCreditContext)
    const hasReset = !!localStorage.getItem('transactional_credit_reset');
    const isAddonActive = hasReset ? !hasReset : transactionalContext?.process?.user_add_on_mode;
    const [step, setStep] = useState(hasReset ? 2 : selectedAddonType ? 2 : 1)
    const handleCloseGuide = () => {
        setStep(1)
    }
    const handleAddonSelectType = (isAddon) => {
        setIsAddon(isAddon);
        localStorage.setItem('chooseAddon', isAddon ? '1' : '0')
        setStep(2)
    }

    return <>
        {step === 0 && <Guide onConfirm={handleCloseGuide} text={guideDefaultText}/>}
        {step === 1 && isAddonActive &&
            <Addon defaultSelectedAddonType={1} mainPrice={transactionalContext.process.prices.main}
                   addonPrice={transactionalContext.process.prices.user_add_on}
                   onSelect={handleAddonSelectType}/>}
        {step === 2 && <GetInitInfo handleBack={() => setStep(1)} isAddon={isAddon} isAddonActive={isAddonActive}
                                    hasReset={hasReset}/>}

    </>
}
export default InitConfirm;